import { render, staticRenderFns } from "./DashboardProjectListing.vue?vue&type=template&id=b47e4172"
import script from "./DashboardProjectListing.vue?vue&type=script&lang=js"
export * from "./DashboardProjectListing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports